export default {
  namespaced: true,

  state: {
    emailTemplatesList: [],
    emailTemplatesData: {},
    editItem: null,
    isLoading: false,
    error: null
  },
  getters: {
    emailTemplatesList(state) {
      return state.emailTemplatesList
    },
    emailTemplatesData(state) {
      return state.emailTemplatesData
    },
    editItem(state) {
      // console.log(state.editItem)
      return state.editItem
    },
    isLoading(state) {
      return state.isLoading
    },
    error(state) {
      return state.error
    },
  },
  mutations: {
    SET_EMAIL_TEMPLATES(state, emailTemplatesList) {
      state.emailTemplatesList = emailTemplatesList 
    },
    SET_EMAIL_TEMPLATES_DATA(state, emailTemplatesData) {
      state.emailTemplatesData = emailTemplatesData
    },
    GET_EMAIL_TEMPLATE(state, index) {
      let editItemIndex = state.emailTemplatesList.map(function(item) { return item.id; }).indexOf(parseInt(index));
      state.editItem = state.emailTemplatesList[editItemIndex]
    },
    SET_LOADING_STATUS(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    REMOVE_ROW(state, index) {
      let removeIndex = state.emailTemplatesList.map(function(item) { return item.id; }).indexOf(index);
      state.emailTemplatesList.splice(removeIndex, 1);
    },
  },
  actions: {
    deleteRow({commit}, dispatch_data) {
      commit('REMOVE_ROW', dispatch_data.id)
    },
  }
}
